import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

   documents = [
      {
        "_id": "65a7d716293d397b20a01d39",
        "name": "Driver License",
        "status": "active",
        "key": "driverLicenceImageUrl",
        "type": "driver"
      },
      {
        "_id": "65a8e764bd711937c9b16496",
        "name": "Vehicle Fintess Certificate",
        "status": "active",
        "key": "vehicleFitnessCertificateImageUrl",
        "type": "vehicle"
      },
      {
        "_id": "65a8f6666511cb64f72aad02",
        "name": "Driver Medical Certificate",
        "status": "active",
        "key": "driverLicenceImageUrl",
        "type": "driver"
      }
    ]
  
    constructor(private http: HttpClient) { }
  
    get() {
      return of(this.documents);
      return this.http.get(urls.API_URL + urls.DOCUMENTS)
        .pipe(catchError(errorHandl));
    }
  
    getById(id: any) {
      return of(this.documents.find(document => document._id === id));
    }
  
    save(id: any, payload: any) {
      if (id) {
        return this.http.put(urls.API_URL + urls.DOCUMENTS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
      } else {
        return this.http.post(urls.API_URL + urls.DOCUMENTS, payload)
        .pipe(catchError(errorHandl));
      }
    }
  
}
